/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Error_TitleInputs */

const es_feedback_modal_error_title = /** @type {(inputs: Feedback_Modal_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error inesperado`)
};

const en_feedback_modal_error_title = /** @type {(inputs: Feedback_Modal_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unexpected error`)
};

/**
* | output |
* | --- |
* | "Unexpected error" |
*
* @param {Feedback_Modal_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_error_title = /** @type {((inputs?: Feedback_Modal_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_error_title(inputs)
	return en_feedback_modal_error_title(inputs)
});
export { feedback_modal_error_title as "feedback.modal.error_title" }